import ProgressBar from '@space-core/components/progressBar'

import type { CardProps } from './types'

import MobileBaseCard from '../base/mobile'

const ProgressMobile = ({ product }: CardProps) => {
  return (
    <MobileBaseCard
      coverImage={product.coverImage}
      icon={product.icon}
      iconRounded={product.iconRounded}
      iconSize={product.iconSize}
      tag={product.tag}>
      <ProgressBar
        className='hot-progress--sm _w-full'
        progressValue={product.completedPercentage}
        data-test='progress-bar'
      />
      {product.pageName && (
        <p data-test='progress-page-name' className='_font-14 _text-gray-900 _mb-0 _mt-4'>
          {product.pageName}
        </p>
      )}
      <h3 className='_text-2 _text-gray-900 _font-weight-bold _m-0 _mt-1 _py-1'>{product.name}</h3>
    </MobileBaseCard>
  )
}

export default ProgressMobile
